var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasStoreCredit)?_c('div',{staticClass:"cart-store-credit-available text-success"},[_c('i',{staticClass:"glyphicon glyphicon-info-sign"}),_vm._v(" Store credit available: "),_c('Currency',{model:{value:(_vm.storeCredit),callback:function ($$v) {_vm.storeCredit=$$v},expression:"storeCredit"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }